export default {
  pageTitle: 'Company Updates',
  viewAll: 'View all',
  showDescription: 'Show description',
  hideDescription: 'Hide description',
  expandNamed: 'Show description for {{title}}',
  collapseNamed: 'Hide description for {{title}}',
  title: 'Title',
  description: 'Description',
  date: 'Date',
  datePlaceholder: 'YYYY-MM-DD',
  actions: 'Actions',
  search: 'Search company updates',
  create: 'New update',
  edit: 'Edit update',
  view: 'Company update details',
  delete: 'Delete update',
  editNamed: 'Edit {{title}}',
  deleteNamed: 'Delete {{title}}',
  deleteConfirmation: 'Delete "{{title}}"?',
  cancel: 'Cancel',
  close: 'Close',
  save: 'Save',
  retry: 'Retry',
  loading: 'Loading company updates...',
  empty: 'No company updates yet',
  noResults: 'No company updates match your search',
  selectCompany: 'Select a company to view company updates',
  created: 'Company update created',
  updated: 'Company update updated',
  deleted: 'Company update deleted',
  validation: {
    titleRequired: 'Enter a title',
    titleLength: 'Title must be 255 characters or fewer',
    descriptionRequired: 'Enter a description',
    descriptionLength: 'Description must be 10,000 characters or fewer',
    dateRequired: 'Select a date',
    dateInvalid: 'Enter a valid date in YYYY-MM-DD format',
  },
  errors: {
    400: 'Some fields or search parameters are invalid. Check them and try again.',
    401: 'Please sign in again to access company updates.',
    403: 'You do not have permission to perform this action for this company.',
    404: 'This company update is missing, deleted, or unavailable in the selected company.',
    general: 'Unable to complete the request. Check your connection and try again.',
  },
};
